import React, { useState } from "react";
import { X, Upload } from "lucide-react";

const inputCls = "w-full bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50 transition-colors";
const labelCls = "text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5";

const LEAVE_TYPES = ["Annual", "Sick", "Casual", "Unpaid", "Maternity", "Paternity", "WFH"];

export default function LeaveModals({ showForm, formData, setShowForm, handleFormChange, handleFormSubmit }) {
  const [submitting, setSubmitting] = useState(false);
  const [submitted,  setSubmitted]  = useState(false);

  if (!showForm) return null;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await handleFormSubmit(e);
      setSubmitted(true);
      setTimeout(() => { setSubmitted(false); setShowForm(false); }, 1500);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[9999] p-4">
      <div className="w-full max-w-md rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_40px_#00ff9022]">

        <div className="flex items-center justify-between px-6 py-4 border-b border-white/5">
          <h2 className="text-sm font-semibold text-white">Apply for Leave</h2>
          <button onClick={() => setShowForm(false)}
            className="w-8 h-8 rounded-lg border border-white/10 bg-white/5 flex items-center justify-center text-white/40 hover:text-white transition-colors">
            <X size={14} />
          </button>
        </div>

        {submitted ? (
          <div className="px-6 py-10 text-center">
            <p className="text-3xl mb-3">✓</p>
            <p className="text-[#00ff90] font-medium">Leave request submitted</p>
            <p className="text-white/40 text-sm mt-1">Your manager will be notified.</p>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="px-6 py-5 space-y-4">

            <div>
              <label className={labelCls}>Leave Type</label>
              <select name="leave_type" value={formData.leave_type} onChange={handleFormChange} required className={inputCls}>
                <option value="">Select type…</option>
                {LEAVE_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className={labelCls}>Start Date</label>
                <input type="date" name="start_date" value={formData.start_date} onChange={handleFormChange} required className={inputCls} />
              </div>
              <div>
                <label className={labelCls}>End Date</label>
                <input type="date" name="end_date" value={formData.end_date} onChange={handleFormChange} required className={inputCls} />
              </div>
            </div>

            <div>
              <label className={labelCls}>Reason</label>
              <textarea name="reason" value={formData.reason} onChange={handleFormChange} rows={2}
                placeholder="Optional details…"
                className={`${inputCls} resize-none placeholder-white/20`} />
            </div>

            <div>
              <label className={labelCls}>Attachment (optional)</label>
              <div className="border border-dashed border-[#00ff90]/20 rounded-lg px-4 py-3 bg-[#00ff90]/5 flex items-center gap-3">
                <Upload size={16} className="text-[#00ff90]/40 shrink-0" />
                <input type="file" name="file" onChange={handleFormChange} className="text-sm text-white/50 w-full" />
              </div>
            </div>

            <div className="flex justify-end gap-2 pt-1">
              <button type="button" onClick={() => setShowForm(false)}
                className="text-xs px-4 py-2 rounded-lg border border-white/10 text-white/40 hover:text-white transition-colors">
                Cancel
              </button>
              <button type="submit" disabled={submitting}
                className="text-xs px-5 py-2 rounded-lg bg-[#00ff90]/15 text-[#00ff90] border border-[#00ff90]/30 hover:bg-[#00ff90]/25 disabled:opacity-40 transition-colors font-medium">
                {submitting ? "Submitting…" : "Submit Request"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}